import * as React from 'react';

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { NavLink } from 'react-router-dom';
import { Container } from '@mui/material';


function ResponsiveAppBar() {
    return (
        <AppBar
            style={{ backgroundColor: '#3b5c31' }}
            className="navbar" position="static">
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                    <NavLink to={process.env.PUBLIC_URL} className="navbar-logo">
                        <img src={process.env.PUBLIC_URL + "/assets/images/ega_logo_simple_2.svg"} style={{ width: "40em" }} alt="ENoD EGA Community" />
                    </NavLink>
                    {/*
                    <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="inherit"
                        >
                            <MenuIcon />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left'
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left'
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{
                                display: { xs: 'block', md: 'none' }
                            }}
                        >
                            {pages.map((page) => (
                                <MenuItem key={page} onClick={handleCloseNavMenu}>
                                    <NavLink
                                        key={page}
                                        style={({ isActive }) => ({ color: isActive ? '#ff7f00' : '#3b5c31' })}
                                        to={'/' + page} > {page}</NavLink>
                                </MenuItem>
                            ))}
                        </Menu>
                    </Box>
                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                        {pages.map((page) => (
                            <NavLink
                                key={page}
                                style={({ isActive }) => ({ color: isActive ? '#ff7f00' : 'white' })}
                                to={'beacon_enod/' + page} > {page}</NavLink>
                        ))}
                    </Box>
                        */}
                </Toolbar>
            </Container>
        </AppBar >
    );
};
export default ResponsiveAppBar;
